import { useTranslation } from '@eti/providers';
import { Heading, Stack, Text } from '@etg/wings';
import { Link } from 'react-router-dom';
import CardWithActionButton from '../../common/CardWithActionButton';
import { routes } from '../../../../../constants/routesAndApisConstants';
import { RebookEligibility, type RebookEligibilityType } from '../../manage-trip/rebooking/models';

interface RebookingRightContentProps {
  rebookEligibilityType: RebookEligibilityType;
}

const RebookingRightContent = ({ rebookEligibilityType }: RebookingRightContentProps) => {
  const { t } = useTranslation();

  if (rebookEligibilityType === RebookEligibility.CHANGE_BY_CUSTOMER) {
    return (
      <CardWithActionButton
        as={Link}
        buttonText={t('ContactUs.Subtopic.Rebooking.Banner.Button.Text')}
        to={routes.CHANGE_TRIP}
      >
        <Stack spacing={8}>
          <Heading as="h5" level={3}>
            {t('ContactUs.Subtopic.Rebooking.Banner.Title')}
          </Heading>
          <Text>{t('ContactUs.Subtopic.Rebooking.Banner.Content')}</Text>
        </Stack>
      </CardWithActionButton>
    );
  }
  return null;
};

export default RebookingRightContent;
